module.exports = __webpack_public_path__ + "img/9_Middle-T.c1cf4bc1.png";